import gql from 'graphql-tag'

export default {
  data () {
    return {
      advertisables: { set: [] },
      mediaPlanEvents: { set: [] },
    }
  },

  computed: {
    mpeFilter () {
      type: null
    },

    /**
     * Gives edited advertisable
     * @returns {Object}
     */
    getAdvertisable () {
      let { id, type, label, url, media = {}, meta = {} } = this.advertisables.set[0] || {}
      let { set = [] } = media
      let { description, price, discount, discountValidity } = meta

      return {
        id: id,
        postsType: type,
        label: label,
        description: description,
        url: url,
        price: price,
        discount: discount,
        media: set,
        discountValidity: discountValidity,
      }
    },

    /**
     * Gives mpe's that belong to given advertisable
     * @returns {Array}
     */
    getMpes () {
      return this.mediaPlanEvents.set || []
    },

    // Allows mpe duplicator to show images
    getAdvertisableId () {
      if (!this.getMpes[0]) return
      return (this.getMpes[0].advertisable || {}).id
    },

    /**
     * Default don't skip advertisables
     * @returns {Boolean}
     */
    skipAdvertisables () {
      return false
    },

    /**
     * Default skips mpe's
     * @returns {Boolean}
     */
    skipMpes () {
      return true
    },

    /**
     * Gives extra meta for MPE's
     * @returns {Object}
     */
    getMeta () {
      let rtr = {}
      let { params: { campaign } } = this.$route
      if (campaign) {
        rtr = { ...rtr, campaign }
      }
      return rtr;
    }
  },

  apollo: {
    advertisables: {
      query: gql`query ($id: [UUID!]) {
        advertisables(id: $id) {
          set {
            id,
            url,
            type,
            label,

            media {
              set {
                id,
                url,
                filesize
              }
            },

            meta {
              ... on AdvertisableImportedProduct {
                description,
                vendor,
                price,
                discount,
                tags
              },

              ... on AdvertisableProduct {
                description,
                price,
                discount,
                discountValidity
              },

              ... on AdvertisablePost {
                description: content
              }
            }
          }
        }
      }`,
      variables () {
        return {
          id: this.getAdvertisableId
        }
      },
      skip() {
        return this.skipAdvertisables
      },
      fetchPolicy: 'cache-and-network',
    },

    mediaPlanEvents: {
      query: gql`query ($id: [UUID!], $adv: [UUID!], $type: [MediaPlanEventType!]) {
        mediaPlanEvents (id: $id, advertisables: $adv, type: $type) {
          set {
            id,
            credentials {
              id,
              type
            },

            advertisable {
              id,
            }
          }
        }
      }`,
      variables () {
        return this.mpeFilter
      },
      fetchPolicy: 'cache-and-network',

      skip() {
        return this.skipMpes
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination/providers/quickPostEditor.js